/*
 * @file shopSearch.js
 * @author: cdtanhongzhao
 * @describe: 搜索模块动态链接
 * @date: 2017-09-25 14:07
 */

import $ from 'jquery';
import manager from '../manager';
import { INTERFACE } from '@/utils/INTERFACE'
import { getParams } from '@/utils/urlQuery'

manager.add('getShopSearch', {
	created(param) {
		var params =getParams()
		$(this.dom).find(".J_minPrice").val(params.minPrice||'')
		$(this.dom).find(".J_maxPrice").val(params.maxPrice||'')
		if(params.keyword){
			$(this.dom).find(".J_searchKeyWord").val(params.keyword)
		}
		let _this = this, venderId = $('#J_venderId').val() || "10002", thisParam = $.extend(true, {
			openUrl: INTERFACE().mall.search.pc(venderId),
			clickNode: '.J_searchBtn',
			searchTextNode: '.J_searchKeyWord',
			minPriceNode: '.J_minPrice',
			maxPriceNode: '.J_maxPrice',
			hotSearchNode: '.J_hotSearch a'
		}, param);
		_this['allParam'] = thisParam;
		$(_this.dom).find(thisParam.hotSearchNode).each(function () {
			$(this).attr("href", thisParam.openUrl + "?keyword=" + $(this).text());
		})
		const jump = () => {
			let minPrice = $(_this.dom).find(thisParam.minPriceNode).length ? "&minPrice=" + $(_this.dom).find(thisParam.minPriceNode).val() : "",
				maxPrice = $(_this.dom).find(thisParam.maxPriceNode).length ? "&maxPrice=" + $(_this.dom).find(thisParam.maxPriceNode).val() : "",
				thisUrl = thisParam.openUrl + "?keyword=" + $(_this.dom).find(thisParam.searchTextNode).val() + minPrice + maxPrice;
			location.href = thisUrl
		}
		$(_this.dom).find(thisParam.clickNode).on("click", () => {
			jump()
		});
		$(_this.dom).find("input").on("keypress", e => {
			if (e.keyCode == "13") {
				jump();
			}
		})
	},
	destroyed(param) {
		let thisParam = this.allParam;
		$(this.dom).find(thisParam.clickNode).off("click");
	}
})
